import { api } from "@/builders/axios";

export const activate_or_deactivate = function (variables: {
  username: string;
  data: {
    is_active: boolean;
    reason: string;
  };
}) {
  const { username, data } = variables;
  return api.post(`/users/${username}/activate-or-deactivate`, data);
};
